import React, {useState} from 'react'
import {shallowEqual, useSelector, useDispatch} from 'react-redux'
import {RootState} from '../../../../setup'
import {isCompanyInTheGracePeriod, IsCurrentPlanFree, checkUpgradePaymentRequired} from '../../../../app/services/Functional'
import BannerCard from '../../../../app/components/common/BannerCard'
import {Dispatch} from 'redux'
import {renewSubscriptionPlan} from '../../../../setup/redux/auth/actions'
import UpgradePlanDialog from '../../../../app/modules/subscription_history/my_subscription/UpgradePlanDialog'

interface GracePeriodProps {
  className?: string
}

const GracePeriod: React.FC<GracePeriodProps> = ({className = ''}) => {

  const dispatch: Dispatch<any> = useDispatch()
  const [isLoading, setIsLoading] = useState(false)
  const [showUpgradeDialog, setShowUpgradeDialog] = useState(false)

  const {active_inspection_company}: any = useSelector<RootState>(
    (state) => ({
      active_inspection_company: state.auth.active_inspection_company,
    }),
    shallowEqual
  )

  const showGracePeriodCard = isCompanyInTheGracePeriod(active_inspection_company)
  const isCurrentPlanFree = IsCurrentPlanFree()
  const isUpgradePaymentRequired = checkUpgradePaymentRequired(active_inspection_company)

  if (!showGracePeriodCard) {
    return null
  }

  const handlePay = async () => {
    setIsLoading(true)
    await dispatch(renewSubscriptionPlan(active_inspection_company?.id))
    setIsLoading(false)
  }

  const handleUpgradeClick = () => {
    setShowUpgradeDialog(true)
  }

  const handleUpgradeDialogClose = () => {
    setShowUpgradeDialog(false)
  }

  const getDescription = () => {
    return `${isCurrentPlanFree ? 'Upgrade' : 'Renew or upgrade'} your plan now to avoid service interruption and continue accessing all features.`
  }

  return (
    <>
      <div className={className}>
        <BannerCard
          title={'Your Plan is in the Grace Period'}
          description={getDescription()}
          variant="expired"
          showButton={!isUpgradePaymentRequired.required}
          buttonText={isCurrentPlanFree ? 'Upgrade Now' : 'Renew Now'}
          onButtonClick={isCurrentPlanFree ? handleUpgradeClick : handlePay}
          buttonLoading={isLoading}
        />
      </div>
      <UpgradePlanDialog show={showUpgradeDialog} onHide={handleUpgradeDialogClose} />
    </>
  )
}

export {GracePeriod}
